import { G, Path, Svg } from "react-native-svg";
interface TapNParkIconProps {
  fillColor?: string;
  strokeColor?: string;
  height?: number;
  width?: number;
  style?: object;
}
const TapNParkIcon: React.FC<TapNParkIconProps> = (props) => (
      <Svg
      fill={props.fillColor}
      stroke={props.strokeColor}
      height={props.height}
      style={props.style}
      viewBox="0 0 278.24 65.66"
      width={props.width}
    >
    <G>
      <Path d="M16.66,8.43v56.94h-8.53V8.43H0V.1h24.5v8.33h-7.84Z" fill="#ffd100" strokeWidth={0} />
      <Path d="M41.65,65.37l-1.18-12.64h-7.55l-1.47,12.64h-7.84L32.34.1h9.41l8.72,65.27h-8.82ZM37.04,16.76l-3.14,28.03h5.68l-2.55-28.03Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M67.23,38.91h-4.7v26.46h-8.53V.1h13.23c5.59,0,10.68,3.04,10.68,11.76v15.29c0,8.62-5.1,11.76-10.68,11.76ZM69.48,11.76c0-2.55-.88-3.72-2.74-3.72h-4.21v23.42h4.21c1.86,0,2.74-1.27,2.74-3.72v-15.98Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M99.86,0v2.35c-2.06,0-3.43,1.57-3.43,5.29h3.23v10.68h-6.86v-9.6c0-5,2.45-8.72,7.06-8.72Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M124.36,65.37l-9.21-31.26-2.65-9.7v40.97h-7.74V.1h8.04l8.23,31.36,2.45,9.8V.1h7.64v65.27h-6.76Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M161.41,38.91h-4.7v26.46h-8.53V.1h13.23c5.59,0,10.68,3.04,10.68,11.76v15.29c0,8.62-5.1,11.76-10.68,11.76ZM163.66,11.76c0-2.55-.88-3.72-2.74-3.72h-4.21v23.42h4.21c1.86,0,2.74-1.27,2.74-3.72v-15.98Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M190.32,65.37l-1.18-12.64h-7.55l-1.47,12.64h-7.84L181.01.1h9.41l8.72,65.27h-8.82ZM185.71,16.76l-3.14,28.03h5.68l-2.55-28.03Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M222.95,65.66c-3.14,0-4.41-3.92-4.41-8.62v-15.58c0-2.25-1.18-4.02-3.43-4.02h-3.82v27.93h-8.62V.1h13.23c5.59,0,10.78,3.04,10.78,11.56v13.72c0,3.92-1.67,6.76-5,8.33,3.33,1.57,5.19,4.51,5.19,8.33v14.5c0,2.94.49,5,1.47,6.66v2.45h-5.39ZM218.15,11.76c0-2.55-.88-3.72-2.74-3.72h-4.12v21.95h3.72c2.06,0,3.14-1.27,3.14-4.02v-14.21Z" fill="#ffd100" strokeWidth={0}/>
      <Path d="M249.41,65.37l-5.39-27.34-2.94,10v17.35h-8.53V.1h8.53v31.36L249.51.1h8.33l-8.13,27.83,8.43,37.44h-8.72Z" fill="#ffd100" strokeWidth={0}/>

    </G>
    <Path d="M268.99.09v1.2h-2.31v6.03h-1.43V1.28h-2.31V.09h6.06ZM276.81,7.31l-.27-4.25c-.03-.56-.03-1.25-.05-2.02h-.08c-.19.64-.4,1.49-.61,2.15l-1.3,4.01h-1.49l-1.3-4.12c-.13-.56-.35-1.41-.51-2.05h-.08c0,.66-.03,1.35-.05,2.02l-.27,4.25h-1.38l.53-7.23h2.15l1.25,3.53c.16.56.29,1.09.48,1.83h.03c.19-.66.35-1.27.51-1.81l1.25-3.56h2.07l.56,7.23h-1.43Z" fill="#ffd100" strokeWidth={0}/>
    </Svg>
);
export default TapNParkIcon;
